/**
 * buildPrintHeader(dateStr, logoSrc) → HTMLElement
 *
 * Returns a detached DOM node for the top of a printed 豆單.
 * Layout: INBO COFFEE logo (left) | 列印時間 (right), separated by a brand-green border.
 *
 * Rules:
 *  - Pure vanilla JS, no React, no external CSS.
 *  - The logo is the real INBO brand logo, passed in as a data-URI (logoSrc) so
 *    html2canvas captures it reliably (data-URI is inline → no network/CORS issue).
 *  - All layout uses inline styles so the header is self-contained.
 *
 * @param {string} dateStr   Pre-formatted date string, e.g. "2026-06-16 09:30"
 * @param {string} logoSrc   Logo image source (data-URI preferred; any same-origin URL works)
 * @param {string} [subtitle] Optional center label, e.g. "一頁 4 支" (列印密度版本標示)
 * @returns {HTMLElement}
 */
export function buildPrintHeader(dateStr, logoSrc, subtitle) {
  // ── Wrapper (full-width flex row) ───────────────────────────────────────────
  const header = document.createElement('div');
  Object.assign(header.style, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 0 12px',
    marginBottom: '10px',
    borderBottom: '2px solid #004632',
    width: '100%',
    boxSizing: 'border-box',
  });

  // ── Left: real INBO COFFEE logo (square, includes wordmark + tagline) ───────
  const logo = document.createElement('img');
  if (logoSrc) logo.src = logoSrc;
  logo.alt = 'INBO COFFEE';
  Object.assign(logo.style, {
    height: '56px',
    width: 'auto',
    display: 'block',
  });

  // ── Right: print-time label ─────────────────────────────────────────────────
  const timeLabel = document.createElement('span');
  Object.assign(timeLabel.style, {
    fontSize: '13px',
    color: '#555555',
    whiteSpace: 'nowrap',
    fontFamily: 'Arial, Helvetica, sans-serif',
  });
  timeLabel.textContent = `列印時間：${dateStr}`;

  // ── Assemble ────────────────────────────────────────────────────────────────
  header.appendChild(logo);

  // ── Center: 列印密度版本標示（一頁 N 支）──────────────────────────────────────
  if (subtitle) {
    const sub = document.createElement('span');
    Object.assign(sub.style, {
      fontSize: '16px',
      fontWeight: '700',
      color: '#004632',
      whiteSpace: 'nowrap',
      fontFamily: '"PingFang TC", "Microsoft JhengHei", Arial, sans-serif',
    });
    sub.textContent = subtitle;
    header.appendChild(sub);
  }

  header.appendChild(timeLabel);

  return header;
}
